// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__2rFvL","active":"Uploader_active__1Fk9Z"};